// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YdqP","placeholdersHeader":"styles_placeholdersHeader__3Ogsn","editorStyle":"styles_editorStyle__gy01w","placeholdersBox":"styles_placeholdersBox__twdqM"};